import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { AuctionType, TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

type SimilarCTAClickedPayload = TrackingPayload & {
    auctionType?: AuctionType;
    houseId: number;
    itemId: number;
    position: number;
};

const trackSimilarCTAClickedAnalytics = (payload: SimilarCTAClickedPayload) => {
    track(TrackingEvents.SimilarItems.SimilarCTAClicked, payload);
};

export const useTrackSimilarCTAClicked = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        ({ auctionType, houseId, itemId, position }: Omit<SimilarCTAClickedPayload, 'pageName' | 'url'>) => {
            trackSimilarCTAClickedAnalytics({
                houseId,
                itemId,
                pageName: getAmplitudePageNameFromPath(pathname),
                position,
                url,
                ...(auctionType !== undefined && { auctionType }),
            });
        },
        [pathname, url]
    );
};
